<template>
  <!--    hero-area-start-->
  <div class="hero-area" style="background-image: url(assets/img/internet-hero-img.png)">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center pt-3">
          <div class="position-relative black">
            <img :src="logo" alt="" width="350" />
            <div class="p-4">
              <h3 v-html="intro"></h3>
            </div>
            <div class="hero-btn" v-if="buttonText">
              <router-link :to="buttonLink" class="theme-btn">{{ buttonText }}</router-link>
            </div>

            <!-- <div class="hero-global">
              <img src="assets/img/g-whait.png" alt="" />
              <p>The Global Employability University Ranking & Survey</p>
              <router-link to="/geurs2020" class="theme-btn">Consult GEURS 2020</router-link>
              <img src="assets/img/glo-bot.png" alt="" class="glo-dot" />
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="page-marker">
      <img src="assets/img/empl-list_2023@2x.png" alt="" />
    </div>
  </div>
  <!--    hero-area-end-->
</template>

<script>
import { getSingle } from '@/api/navItems';

export default {
  data() {
    return {
      textElements: {}
    };
  },
  props: {
    logo: {
      type: String,
      default: 'assets/img/logodl-2.png'
    },
    intro: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    buttonLink: {
      type: String,
      default: ''
    }
  },
  created() {
    getSingle('home-entreprises').then(res => {
      this.textElements = res.text_template;
    });
  }
};
</script>

<style lang="scss" scoped>
h3,
h4 {
  margin: 0px 0px 15px;
}

.black {
  color: black;
}

.bold {
  font-weight: bold;
}

.theme-btn {
  background: #0044ff;
}
</style>
